import { axios } from '../../../axios';
const addToFavApi = (data) => {
  return axios.post('/users/fav', data)
}

const removeFavApi = (id) => {
  return axios.delete(`/users/fav/${id}`)
}

const addFeature = (id) => {
  return axios.post(`/properties/feature/${id}`)
}

export { addToFavApi, removeFavApi, addFeature }